export class UserProfile {

    userName: string;
    userPicture: string;
  
    constructor(userName: string, userPicture: string) {
      this.userName = userName;
      this.userPicture = userPicture
    }
  }